import { Link } from "react-router-dom";
import { TRENDING } from "@/data/content";
import { resolveAssetPath } from "@/lib/assets";

export const Destinations = () => {
  return (
    <section
      id="destinations"
      data-testid="trending-section"
      className="bg-white py-14"
    >
      <div className="max-w-[1280px] mx-auto px-4 lg:px-6">
        <div className="text-center mb-10">
          <h2 className="font-serif-display text-4xl md:text-5xl text-[var(--navy)] leading-tight">
            Trending <span className="text-[var(--yellow-2)]">Group Holidays</span>
          </h2>
          <p className="text-gray-600 mt-2 text-sm md:text-base">
            Discover iconic destinations across India and the world with our group tours!
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {TRENDING.map((t, i) => (
            <Link
              key={t.name}
              to={`/search?q=${encodeURIComponent(t.name)}`}
              data-testid={`trending-card-${i}`}
              className="group relative rounded-lg overflow-hidden aspect-[5/6] shadow-sm hover:shadow-xl transition-shadow block"
            >
              <img
                src={resolveAssetPath(t.image)}
                alt={t.name}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-3 text-white">
                <div className="font-bold text-lg leading-tight drop-shadow">
                  {t.name}
                </div>
                <div className="text-[10px] text-white/90 mt-1">
                  {t.tours} | {t.departures}
                </div>
                <div className="text-[10px] text-white/80 mt-0.5">
                  {t.travelled}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
